import { render, staticRenderFns } from "./permission_modal.vue?vue&type=template&id=5a20d16b&scoped=true&"
import script from "./permission_modal.vue?vue&type=script&lang=js&"
export * from "./permission_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20d16b",
  null
  
)

export default component.exports